"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EventMissionDetail = void 0;
const base_model_1 = require("../../base-model");
const event_mission_detail_schema_1 = require("./event-mission-detail.schema");
class EventMissionDetail extends base_model_1.BaseModel {
    constructor(data, skipValidation) {
        super(data, skipValidation);
    }
    getDefaults() {
        return {};
    }
    getSchema() {
        return event_mission_detail_schema_1.eventMissionDetailSchema;
    }
}
exports.EventMissionDetail = EventMissionDetail;
